/**
 * 分类数据模型（核心逻辑层）
 * 1. 调用 Services 层接口；2. 数据校验；3. 缓存业务；4. 提供页面调用方法
 */
import { services } from '../services';

// 缓存配置
const CACHE_KEY = 'CATEGORY_LIST';
const CACHE_EXPIRE = 60 * 60 * 1000; // 1小时有效期

export const CategoryModel = {
  /**
   * 获取所有分类（带缓存+数据校验）
   * @returns {Promise<Array>} 格式化后的分类列表
   */
  getCategories: async ({homeShow = ''}) => {
    // 1. 先查本地缓存
    const key = CACHE_KEY + '_' + homeShow
    const cacheData = localStorage.getItem(key);
    const cacheTime = localStorage.getItem(`${key}_TIME`);
    if (cacheData && cacheTime && Date.now() - Number(cacheTime) < CACHE_EXPIRE) {
      return JSON.parse(cacheData);
    }

    // 2. 缓存失效，调用 Services 层接口
    const response = await services.category.getCategories({homeShow});
    if (!response.ok) throw new Error('分类接口请求失败');
    const rawData = await response.json();
    const data = rawData?.result;
    if (data?.length > 0) {
      // 4. 存入缓存
      localStorage.setItem(key, JSON.stringify(data));
      localStorage.setItem(`${key}_TIME`, Date.now().toString());
    }

    return data;
  },

  /**
   * 获取默认分类ID（业务逻辑：优先URL参数，无则取第一个分类）
   * @param {Array} categoryList 分类列表
   * @param {string} urlCategory URL中的分类ID
   * @returns {string} 有效分类ID
   */
  getDefaultCategoryId: (categoryList, urlCategory) => {
    if (urlCategory && categoryList.some(cat => cat.id === urlCategory)) {
      return urlCategory;
    }
    return categoryList[0]?.id || '';
  },

  /**
   * 私有方法：校验分类列表数据（内部使用，不对外暴露）
   * @param {Array} rawList 接口原始响应数据
   * @returns {Array} 校验后的分类列表
   */
  _validateList: (rawList) => {
    if (!Array.isArray(rawList)) throw new Error('分类接口返回格式错误（非数组）');
    return rawList.map(item => {
      if (!item?.id) throw new Error('分类缺少必填字段：id');
      if (!item?.name) throw new Error(`分类ID:${item.id} 缺少名称`);
      if (!item?.icon) throw new Error(`分类ID:${item.id} 缺少图标`);
      // 数据格式化（确保字段类型统一）
      return {
        id: String(item.id),
        name: item.name.trim(),
        icon: item.icon.trim()
      };
    });
  }
};